import { useRef } from 'react';
import papers from "../images/papers.png"
import backgroundImageUrl from "../images/15.png";
import mobilebackgroundImageUrl from "../images/21.png";
import transformationImageUrl from "../images/16.png";
import healingImageUrl from "../images/17.png";
import Footer from '../components/Footer';
import { FaArrowRight } from 'react-icons/fa';
import Header from '../components/Header'; 
import rewireImage from "../images/23.png"; 
import comingSoonImage from "../images/Coming-Soon.png"; 
import awardImage from "../images/18.png"; 
function Rewire() {
    const headerRef = useRef();
    const settings = {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };
    const buttonStyle = "flex items-center space-x-2 text-white font-semibold py-2 rounded-md transition duration-300";

    // Common styling for the image container (to mimic the border/glow effect)
    const imageContainerBase = "aspect-video w-[15em] md:w-[30em] flex items-center justify-center p-0.5 rounded-lg overflow-hidden";

    // Specific image container styles 
    const audioRef = useRef(null);
    const playSound = () => {
        audioRef.current.currentTime = 0; // restart sound if clicked again
        audioRef.current.play();
    };
    return (
        <div className="mb-[120px] md:mb-0">
            <Header pageName="Rewire Now" />
            <div className="min-h-screen background-with-image text-white flex items-center justify-end"  >
                <div className='container mx-auto relative px-4'> 
                        <img
                            src={rewireImage}
                            alt="Logo"
                            style={{
                            top: '-10%',
                            left: '10%',  
                            transform: 'rotate(-15deg)'
                        }}
                            className="hidden md:block absolute w-[30em]"
                        /> 
                         <img
                            src={rewireImage}
                            alt="Logo" 
                            className="mb-4 mx-auto md:hidden w-[90%] "
                        /> 
                         <img
                            src={comingSoonImage}
                            alt="Logo" 
                            className="mb-4 md:mt-8 mx-auto w-full md:w-[40rem] "
                        />  
                    <p className='poppins text-xl lg:text-2xl text-center mx-auto uppercase mt-4 md:mt-4'>Be the first to know</p>
                    <form className="w-[90%] mt-0 md:w-2/3 z-10 flex items-center bg-white rounded-full shadow-lg overflow-hidden md:max-w-lg md:w-full mx-auto">
                        <input
                            type="email"
                            placeholder="EMAIL ADDRESS"
                            className="flex-grow px-4 py-3 text-sm italic text-gray-400 placeholder-gray-400 focus:outline-none font-semibold"
                            aria-label="Email Address"
                            required
                        />
                        <button
                            type="submit"
                            className="bg-[#80a2a5] p-[5px] mr-[5px] border-2 border-[#80a2a5] hover:bg-transparent hover:text-[#80a2a5] rounded-full transition duration-300"
                            aria-label="Submit email"
                        >
                            <FaArrowRight />
                        </button>
                    </form>
                </div> 
            </div>
            <Footer />
        </div>
    );
}
export default Rewire;